export default __webpack_public_path__ + "static/media/auth_technological.58308da8.svg";